import React from 'react';
import { TextField } from '@mui/material';
import {
  nowDateLocal,
  createFutureDateChangeHandler,
  getFutureDateInputProps,
  FUTURE_DATE_HELPER,
} from '../../utils/datetimeLocal';

/**
 * date field that blocks past selection (min = today or `minDate`).
 */
const FutureDateTextField = ({
  value,
  onChange,
  minDate,
  disablePast = true,
  showFutureHelper = false,
  helperText,
  inputProps: inputPropsProp,
  InputLabelProps,
  ...rest
}) => {
  const min = minDate ?? nowDateLocal();
  const handleChange = disablePast
    ? createFutureDateChangeHandler(onChange, min)
    : (e) => onChange(e.target.value);

  const resolvedHelper =
    helperText !== undefined
      ? helperText
      : showFutureHelper
        ? FUTURE_DATE_HELPER
        : undefined;

  return (
    <TextField
      type="date"
      value={value ?? ''}
      onChange={handleChange}
      InputLabelProps={{ shrink: true, ...InputLabelProps }}
      inputProps={getFutureDateInputProps(min, inputPropsProp)}
      helperText={resolvedHelper}
      {...rest}
    />
  );
};

export default FutureDateTextField;
